import { TicketRepository } from '../repositories/TicketRepository'

export function UpdateAreaPriorityCase(ticketRepository: TicketRepository) {
  return async function ({ areaId, data }) {
    return await ticketRepository.updateAreaPriority({
      areaId,
      data
    })
  }
}
